import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import {
  login,
  register,
  UserSession
} from '../utils'
import logo from "../assets/tom-logo-icon-black.jpg"
import { ID, Client, Account, Databases } from "appwrite";
import { AppProvider } from '@toolpad/core/AppProvider';
import { SignInPage } from '@toolpad/core/SignInPage';
import { useTheme, createTheme } from '@mui/material/styles';
import { Resend } from 'resend';
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Link,
  IconButton,
  Button,
  Stack,
  Box,
  Typography
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';


const client = new Client()
  .setEndpoint(process.env.REACT_APP_ENDPOINT)
  .setProject(process.env.REACT_APP_PROJECT_ID);

const users = new Account(client);
const databases = new Databases(client);


const providers = [{ id: 'nodemailer', name: 'Email' }];

const BRANDING = {
  logo: (
    <img
      // src="/src/assets/tom-logo-icon-black.jpg"
      src={logo}
      alt="Takeoff Monkey Widgets Logo"
      style={{ height: 48 }}
    />
  ),
  title: 'Takeoff Monkey Widgets',
};


export default function ResetPassword() {
  const navigate = useNavigate()
  const [session, setSession] = useAtom(UserSession)

  if (session) {
    navigate('/');
  }

  useEffect(() => {
    console.log("UserSession:", session);
  }, [session]);
  
  const handleReset = async (formData, callbackUrl) => {
    const email = formData.get('email');
    const token = ID.unique();

    try {
      const resend = new Resend('re_ScQjx8ei_HteTcJ6GRgv1RGJqiqJJrvoL');

      resend.emails.send({
        from: 'onboarding@resend.dev',
        to: 'konur@takeoffmonkey.com',
        subject: 'Hello World',
        html: '<p>Congrats on sending your <strong>first email</strong>!</p>'
      });
      console.log("Email sent");

      // export async function POST() {
      //   const res = await fetch('https://api.resend.com/emails', {
      //     method: 'POST',
      //     headers: {
      //       'Content-Type': 'application/json',
      //       Authorization: `Bearer ${RESEND_API_KEY}`,
      //     },
      //     body: JSON.stringify({
      //       from: 'konur@takeoffmonkey.com',
      //       to: ['konurpapa@gmail.com'],
      //       subject: 'Hello World',
      //       html: '<strong>it works!</strong>',
      //     }),
      //   });

      //   if (res.ok) {
      //     const data = await res.json();
      //     return Response.json(data);
      //   }
      // }


      // const user = await login(email, password);
      // setSession(user);
      // console.log("User logged in:", user);
      // navigate(callbackUrl || '/');
    } catch (error) {
      console.error(error);
      alert("Sign-in error: " + error.message);
    }
  }

  const theme = createTheme({
    palette: {
      mode: 'dark',
    },
  });

  return (
    <AppProvider branding={BRANDING} theme={theme}>
      <Stack direction="row" sx={{ maxWidth: '500px', mx: 'auto' }}>
        <Button
          variant="text"
          onClick={() => navigate('/login')}
          sx={{
            position: 'relative',
            display: 'flex',
            my: 'auto',
            height: '2.5em',
            width: 'fit-content',
            alignItems: 'center'
          }}
        >
          <ArrowBackIosNewOutlinedIcon sx={{ mr: '0.5em', fontSize: '1em' }} />
          Back&nbsp;
        </Button>
        <SignInPage
          signIn={handleReset}
          providers={providers}
          slotProps={{
            emailField: {
              sx: { '& .MuiInputBase-root': { height: '2.5em', overflow: 'hidden' } }
            }
          }}
          slots={{
            title: () => <Typography variant="h4" sx={{ mt: 1, mb: 1 }}>Reset password</Typography>,
            subtitle: () => <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary', textAlign: 'center' }}>Enter the email associated with your account</Typography>,
            submitButton: () => <Button variant="contained" fullWidth size="large" sx={{ mt: 2 }}>Send reset email</Button>
          }}
        />
      </Stack>
    </AppProvider>
  );
}